import Entry from 'admin-config/lib/Entry';

export default function maSwitchField() {
    return {
        scope: {
            'field': '&',
            'value': '=',
            'datastore': '&'
        },
        restrict: 'E',
        link: {
            pre: function(scope) {

            }
        },
        template:
`
 <md-switch class="md-primary" md-no-ink  ng-model="value"> </md-switch>
`
    };
};

maSwitchField.$inject = [];


/** WEBPACK FOOTER **
 ** ./js/directives/ma_switch_field.js
 **/